import type { PermissionLevel } from "@onemileauto/shared-types";

/**
 * Plain-English labels/descriptions for the schema's permission_level
 * values — "owner"/"full"/"read_only"/"send_as" are fine as internal
 * identifiers but not something to show a non-technical shop owner
 * verbatim. Centralized here (rather than inline in each admin form) so
 * the wording stays consistent between the grant form and the ACL list.
 */
export const PERMISSION_LEVEL_OPTIONS: ReadonlyArray<{ value: PermissionLevel; label: string; description: string }> = [
  { value: "full", label: "Full access", description: "Can read, send, and archive mail" },
  { value: "read_only", label: "Read only", description: "Can view mail but not send or archive" },
  { value: "send_as", label: "Send as", description: "Can send mail using this address" },
  { value: "owner", label: "Owner", description: "Full control, including managing who has access" },
];

export function permissionLevelLabel(level: PermissionLevel): string {
  return PERMISSION_LEVEL_OPTIONS.find((o) => o.value === level)?.label ?? level;
}
